import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { useAuth } from "@/context/AuthContext";
import { fmtDate } from "@/constants/sports";
import { api, formatApiError } from "@/lib/api";

export const MembersTab = () => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/admin/members").then((r) => setItems(r.data.items)), []);
  useEffect(() => { load(); }, [load]);

  const toggle = async (m, active) => {
    try {
      await api.patch(`/admin/members/${m.id}`, { active });
      toast.success(`${m.name || m.email} ${active ? "reactivated" : "deactivated"}`);
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="overflow-x-auto rounded-xl border border-slate-800">
      <table className="w-full min-w-[640px] text-sm">
        <thead className="bg-[#131927]">
          <tr className="text-left">{["Member", "Role", "Joined", "Status", "Active"].map((h) => <th key={h} className="eyebrow px-5 py-3 font-normal">{h}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-slate-800">
          {items.map((m) => (
            <tr key={m.id} data-testid={`member-row-${m.id}`}>
              <td className="px-5 py-4"><div className="font-semibold">{m.name}</div><div className="text-xs text-slate-500">{m.email}</div></td>
              <td className="px-5 py-4 font-data text-xs uppercase text-slate-300">{m.role}</td>
              <td className="px-5 py-4 text-slate-400">{fmtDate(m.created_at)}</td>
              <td className="px-5 py-4">
                <span data-testid={`member-status-${m.id}`} className={`font-data text-[11px] uppercase ${m.active ? "text-emerald-400" : "text-red-400"}`}>{m.active ? "Active" : "Deactivated"}</span>
              </td>
              <td className="px-5 py-4">
                <Switch data-testid={`member-active-switch-${m.id}`} checked={m.active} disabled={m.id === user?.id} onCheckedChange={(v) => toggle(m, v)} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
